import {firstCharacter} from "@Features/input/phoneField/functions/firstCharacter";

export const isFirstCharacterZero = (phoneNumber) => firstCharacter(phoneNumber) === '0'